import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../api';
import { useSession } from '../session';

export function Login() {
  const { refresh, productName } = useSession();
  const navigate = useNavigate();
  const location = useLocation() as { state?: { returnTo?: string } };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api<{ next: 'mfa' | 'enrol' }>('/api/auth/login', { method: 'POST', body: { email, password } });
      await refresh();
      if (result.next === 'enrol') navigate('/enrol');
      else navigate('/mfa', { state: { returnTo: location.state?.returnTo } });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not sign in');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card narrow">
      <h1>Sign in to {productName}</h1>
      <p className="lede">Your work email and password, then your authenticator or passkey.</p>
      <form onSubmit={submit}>
        {error && <div className="alert">{error}</div>}
        <label>
          Email
          <input id="login-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>
          Password
          <input id="login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button type="submit" className="block" disabled={busy}>{busy ? 'Signing in…' : 'Continue'}</button>
      </form>
      {/* The ways out sit under the form rather than inside it, so the button is the last thing the form
          says and nothing reads as a second way to submit it. */}
      <p className="small muted" style={{ marginTop: 20 }}>
        Lost your authenticator and passkeys? <Link to="/forgot-factors">Ask an owner to verify you</Link>.
      </p>
      <p className="small muted" style={{ marginBottom: 0 }}>
        Have an invite code? <Link to="/signup">Create a workspace</Link>.
      </p>
    </div>
  );
}
